import { Box, Typography, useTheme } from "@mui/material";
import { DashboardIcon } from "./DashboardBuilder";

export default function DashboardHeroCard({ value, icon, label, color }) {
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";

  const Icon = icon ? DashboardIcon(icon) : null;

  return (
    <Box
      sx={{
        backgroundColor: isDark ? "rgba(255,255,255,0.05)" : "rgba(0,0,0,0.02)",
        border: `1px solid ${isDark ? "rgba(255,255,255,0.08)" : "rgba(0,0,0,0.08)"}`,
        borderTop: `3px solid ${color}`,
        borderRadius: 1,
        px: { xs: 2, sm: 3 },
        py: { xs: 1.75, sm: 2.5 },
        textAlign: "center",
        boxShadow: isDark
          ? "0 2px 8px rgba(0,0,0,0.3)"
          : "0 2px 8px rgba(0,0,0,0.1)"
      }}
    >
      {Icon && (
        <Box sx={{ mb: 1.5 }}>
          <Icon size="lg" style={{ color }} />
        </Box>
      )}
      <Typography
        variant="h3"
        sx={{
          fontWeight: 700,
          color: theme.palette.text.primary,
          lineHeight: 1,
          mb: 0.75
        }}
      >
        {value}
      </Typography>
      <Typography
        variant="caption"
        sx={{
          color: theme.palette.text.secondary,
          textTransform: "uppercase",
          letterSpacing: "0.12em",
          fontWeight: 600,
          fontSize: "0.65rem"
        }}
      >
        {label}
      </Typography>
    </Box>
  );
}
